const inputSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;

export const triggerInputChangeEvent = (input: HTMLInputElement, value: string) => {
    inputSetter?.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
};
